import Vue from 'vue'
import Router from 'vue-router'
import FontAwsome from 'font-awesome/css/font-awesome.min.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.use(Router)

//学习园地-首页
// import ItemBankIndex from '../views/ItemBank/ItemBankIndex'
//学习园地-开始听课
// import StarClasses from '../views/lessons/StarClasses'
//继续上次做题
// import LastProblem from '../views/ItemBank/GoonlastProblem/LastProblem'
// import sjLastProblem from '../views/ItemBank/LastProblem'

//章节练习
// import StartDoIndex from '../components/StartDo/StartDoIndex'
// import practice from '../components/4Lesson/practice'

//在线评测
// import OnlineJudgeIndex from '../views/ItemBank/OnlineJudge/OnlineJudgeIndex'

//资讯
// import InformationIndex from '../views/information/informationIndex'
//资讯详情
// import InformDes from '../views/information/informDes'
// import InformRight from '../components/inform/informright'


// import StartAttendingIndex from '../components/StartAttending/StartAttendingIndex'
// import HaveClass from '../components/RecordsClass/HaveClass'
// import StartProblemIndex from '../components/StartProblem/StartProblemIndex'
// import HaveMakeRecord from '../components/MakeRecord/HaveMakeRecord'
// import DailyTasks from '../components/4Lesson/dailyTasks'
// import ItemBankHome from '../components/4Lesson/ItemBankHome'


//地址管理
// import AddressManagementIndex from '../views/PersonalCenter/AddressManagement/AddressManagementIndex'

// import MyOrderIndex from '../components/MyOrderMenu/MyOrderIndex'
// import MyOrder from '../components/4Lesson/myOrder'
// import IntegralDetails from '../components/4Lesson/IntegralDetails'
// import ManagementIndex from '../components/AccountManagement/ManagementIndex'
// import MessageCenterIndex from '../components/MessageCenter/MessageCenterIndex'
// import ConsultationIndex from '../components/Consultation/ConsultationIndex'

//订单详情
// import OrderDetails from '../components/4Lesson/OrderDetails'
//定制每日任务
// import CustomizeDailyTasksIndex from '../views/CustomizeDailyTasks/CustomizeDailyTasksIndex'


//....................................................
// import IndexIndex from '../views/index/index'
// import ViewParsing from '../views/ItemBank/GoonlastProblem/ViewParsing'

//在线评测做题页面
// import SubjectIndex from '../components/subject/subjectIndex'
// import SubjectIndexs from '../components/subject/subjectIndexs'
// import AnalysisIndex from '../views/ItemBank/GoonlastProblem/AnalysisIndex'

//我的收藏
// import MyCollection from '../views/ItemBank/GoonlastProblem/MyCollection'

//图书纠错详情
// import DetailsBookError from '../views/PersonalCenter/ConsultingCenter/DetailsBookError'


//讲堂页面
// import Forum from '../views/lessons/Forum'

//直播页面
// import LiveIndex from '../views/lessons/LiveIndex'

//购买页面
// import Buys from '../views/BuyLesson/buy'

//只能积分购买页面
// import InteBuy from '../views/BuyLesson/inteBuy'

//错题重做
// import ReworkQuestions from '@/views/ItemBank/ReworkQuestions/reworkQuestions'
//随机练习--查看
// import RandomExercises from '@/views/ItemBank/randomExercises/RandomExercises'

//每日任务做题
// import DailyTasksItem from '@/views/DailyTasks/DailyTasksItem'


const router = new Router({
	routes: [{
			path: '/',
			redirect: '/index'
		},
		{
			path: '/login',
			component: resolve => require(['@/views/home/login'], resolve),
		},
		{
			path: '/index',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/index',
				component: resolve => require(['@/views/home/index'], resolve),
			}, ]
		},
		{
			path: '/goodTeacher',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/goodTeacher',
				component: resolve => require(['@/views/index/goodTeacher'], resolve),
			}, ]
		},
		{
			path: '/teacherDetail',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/teacherDetail',
				component: resolve => require(['@/views/index/teacherDetail'], resolve),
			}, ]
		},
		{
			path: "/lesindex",
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/lesindex',
				component: resolve => require(['@/views/lessons/lesindex'], resolve),
			}]
		},
		{
			path: "/courseList",
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/courseList',
				component: resolve => require(['@/views/cart/courseList'], resolve),
			}]
		},
		{
			path: "/ItemBankIndex",
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/ItemBankIndex',
				component: resolve => require(['@/views/ItemBank/ItemBankIndex'], resolve),
			}]
		},

		{
			path: "/informationIndex",
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/informationIndex',
				component: resolve => require(['@/views/information/informationIndex'], resolve),
				children: [{
					path: '/informationIndex',
					component: resolve => require(['@/components/inform/informright'],
						resolve),
				}]
			}]
		},
		{
			path: "/PersonalCenterIndex",
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: "/PersonalCenterIndex",
				component: resolve => require(['@/views/PersonalCenter/PersonalCenterIndex'],
					resolve),
			}]
		},

		{
			path: '/ourseDetailsc',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/ourseDetailsc',
				component: resolve => require(['@/views/lessons/ourseDetailsc'], resolve),
			}]
		},
		{
			path: '/lesindex/StarClasses',
			component: resolve => require(['@/views/lessons/StarClasses'], resolve)
		},
		{
			path: '/LastProblem',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/LastProblem',
				component: resolve => require(['@/views/ItemBank/GoonlastProblem/LastProblem'],
					resolve),
			}, ]
		},
		{
			path: '/ChapterExercisesIndex',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: "/ChapterExercisesIndex",
				component: resolve => require(['@/components/StartDo/StartDoIndex'], resolve),
				children: [{
						path: "/ChapterExercisesIndex",
						component: resolve => require(['@/components/4Lesson/practice'],
							resolve)
					},
					{
						path: "/StartAttendingIndex",
						component: resolve => require([
							'@/components/StartAttending/StartAttendingIndex'
						], resolve)
					},
					{
						path: "/HaveClass",
						component: resolve => require(['@/components/RecordsClass/HaveClass'],
							resolve)
					},
					{
						path: "/StartProblemIndex",
						component: resolve => require([
							'@/components/StartProblem/StartProblemIndex'
						], resolve)
					},
					{
						path: "/HaveMakeRecord",
						component: resolve => require([
							'@/components/MakeRecord/HaveMakeRecord'], resolve)
					},
					{
						path: "/DailyTasks",
						component: resolve => require(['@/components/4Lesson/dailyTasks'],
							resolve)
					},
					{
						path: "/ItemBankHome",
						component: resolve => require(['@/components/4Lesson/ItemBankHome'],
							resolve)
					},

				]
			}]
		},
		{
			path: '/OnlineJudgeIndex',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/OnlineJudgeIndex',
				component: resolve => require(['@/views/ItemBank/OnlineJudge/OnlineJudgeIndex'],
					resolve),
			}, ]
		},
		{
			path: "/AddressManagementIndex",
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: "/AddressManagementIndex",
				component: resolve => require(['@/components/MyOrderMenu/MyOrderIndex'], resolve),
				children: [{
						path: "/AddressManagementIndex",
						component: resolve => require([
							'@/views/PersonalCenter/AddressManagement/AddressManagementIndex'
						], resolve),
					},
					{
						path: "/MyOrder",
						component: resolve => require(['@/components/4Lesson/myOrder'], resolve)
					},
					{
						path: "/IntegralDetails",
						component: resolve => require(['@/components/4Lesson/IntegralDetails'],
							resolve)
					},
					{
						path: "/ManagementIndex",
						component: resolve => require([
							'@/components/AccountManagement/ManagementIndex'
						], resolve)
					},
					{
						path: "/MessageCenterIndex",
						component: resolve => require([
							'@/components/MessageCenter/MessageCenterIndex'
						], resolve)
					},
					{
						path: "/ConsultationIndex",
						component: resolve => require([
							'@/components/Consultation/ConsultationIndex'
						], resolve)
					},
					{
						path: "/shoppingCar",
						component: resolve => require(['@/components/cart/shoppingCar'],
							resolve)
					},
					{
						path: "/myCoupon",
						component: resolve => require(['@/components/cart/myCoupon'], resolve)
					},
					{
						path: "/promotion",
						component: resolve => require(['@/components/promotion/promotion'],
							resolve)
					}
				]
			}]
		},
		{
			path: '/OrderDetails',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/OrderDetails',
				component: resolve => require(['@/components/4Lesson/OrderDetails'], resolve)
			}]
		},
		{
			path: "/CustomizeDailyTasksIndex",
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: "/CustomizeDailyTasksIndex",
				component: resolve => require([
					'@/views/CustomizeDailyTasks/CustomizeDailyTasksIndex'
				], resolve)
			}]
		},
		{
			path: '/informDes',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/informDes',
				component: resolve => require(['@/views/information/informDes'], resolve),
				children: [{
					path: '/informDes',
					component: resolve => require(['@/components/inform/informright'],
						resolve),
				}],
			}]
		},
		{
			path: '/couponCentre',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/couponCentre',
				component: resolve => require(['@/views/cart/couponCentre'], resolve)
			}]
		},
		{
			path: '/cartAccount',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/cartAccount',
				component: resolve => require(['@/views/cart/cartAccount'], resolve)
			}]
		},
		{
			path: '/orderDetail',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/orderDetail',
				component: resolve => require(['@/views/cart/orderDetail'], resolve)
			}]
		},
		{
			path: '/index/index',
			component: resolve => require(['@/views/index/index'], resolve)
		},
		{
			path: '/ViewParsing',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/ViewParsing',
				component: resolve => require(['@/views/ItemBank/GoonlastProblem/ViewParsing'],
					resolve),
			}]
		},
		{
			path: '/SubjectIndex',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/SubjectIndex',
				component: resolve => require(['@/components/subject/subjectIndex'], resolve),
			}, ]
		},

		{
			path: '/SubjectIndexs',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/SubjectIndexs',
				component: resolve => require(['@/components/subject/subjectIndexs'], resolve),
			}, ]
		},
		{
			path: '/AnalysisIndex',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/AnalysisIndex',
				component: resolve => require(['@/views/ItemBank/GoonlastProblem/AnalysisIndex'],
					resolve),
			}, ]
		},
		{
			path: '/MyCollection',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/MyCollection',
				component: resolve => require(['@/views/ItemBank/GoonlastProblem/MyCollection'],
					resolve),
			}, ]
		},
		{
			path: '/sjLastProblem',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/sjLastProblem',
				component: resolve => require(['@/views/ItemBank/LastProblem'], resolve),
			}, ]
		},
		{
			path: "/DetailsBookError",
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: "/DetailsBookError",
				component: resolve => require(['@/components/MyOrderMenu/MyOrderIndex'], resolve),
				children: [{
						path: "/DetailsBookError",
						component: resolve => require([
							'@/views/PersonalCenter/ConsultingCenter/DetailsBookError'
						], resolve),
					},
					{
						path: "/MyOrder",
						component: resolve => require(['@/components/4Lesson/myOrder'], resolve)
					},
					{
						path: "/IntegralDetails",
						component: resolve => require(['@/components/4Lesson/IntegralDetails'],
							resolve)
					},
					{
						path: "/ManagementIndex",
						component: resolve => require([
							'@/components/AccountManagement/ManagementIndex'
						], resolve)
					},
					{
						path: "/MessageCenterIndex",
						component: resolve => require([
							'@/components/MessageCenter/MessageCenterIndex'
						], resolve)
					},
					{
						path: "/ConsultationIndex",
						component: resolve => require([
							'@/components/Consultation/ConsultationIndex'
						], resolve)
					}
				]
			}]
		},
		{
			path: '/Forum',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/Forum',
				component: resolve => require(['@/views/lessons/Forum'], resolve),
			}]
		},
		{
			path: '/LiveIndex',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/LiveIndex',
				component: resolve => require(['@/views/lessons/LiveIndex'], resolve),
			}]
		},
		{
			path: '/liveSec',
			name: 'liveSec',
			component: resolve => require(['@/views/lessons/liveSec'], resolve),
		},
		{
			path: '/Buys',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/Buys',
				component: resolve => require(['@/views/BuyLesson/buy'], resolve),
			}]
		},
		{
			path: '/InteBuy',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/InteBuy',
				component: resolve => require(['@/views/BuyLesson/inteBuy'], resolve),
			}]
		},
		{
			path: '/vipBuy',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/vipBuy',
				component: resolve => require(['@/views/BuyLesson/vipBuy'], resolve),
			}]
		},
		{
			path: '/live',
			component: resolve => require(['@/views/live/live'], resolve),
		},
		{
			path: '/dailyCourse',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/dailyCourse',
		 	component: resolve => require(['@/views/lessons/dailyCourse'], resolve),
			}]
		},
		//  错题重做
		{
			path: '/ReworkQuestions',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/ReworkQuestions',
				component: resolve => require(['@/views/ItemBank/ReworkQuestions/reworkQuestions'],
					resolve),
			}]
		},
		//  随机练习-查看
		{
			path: '/RandomExercises',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/RandomExercises',
				component: resolve => require(['@/views/ItemBank/randomExercises/RandomExercises'],
					resolve),
			}]
		},
		// 每日任务做题
		{
			path: '/DailyTasksItem',
			component: resolve => require(['@/components/index/momes'], resolve), //momes,
			children: [{
				path: '/DailyTasksItem',
				component: resolve => require(['@/views/DailyTasks/DailyTasksItem'], resolve),
			}]
		},
		// 医学考试系统
		{
			path: '/systemIndex',
			component: resolve => require(['@/views/medicalSystem/home/index'], resolve)
		},
		{
			path: '/systemStart',
			component: resolve => require(['@/views/medicalSystem/start/start'], resolve)
		},
		{
			path: '/systemExam',
			component: resolve => require(['@/views/medicalSystem/exam/exam'], resolve)
		},
		{
			path: '/systemAnalysis',
			component: resolve => require(['@/views/medicalSystem/analysis/analysis'], resolve)
		}
	],
});

router.beforeEach((to, from, next) => {
	if (to.path === '/login') {
		next();
	} else {
		let token = localStorage.getItem('Authorization');

		if (token === 'null' || token === '') {
			next('/login');
		} else {
			next();
		}
	}
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js